import { render } from "./ReportsTable.vue?vue&type=template&id=4c61e396&scoped=true"
import script from "./ReportsTable.vue?vue&type=script&lang=js"
export * from "./ReportsTable.vue?vue&type=script&lang=js"

import "./reports-table.scss?vue&type=style&index=0&id=4c61e396&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c61e396"]])

export default __exports__